import React from 'react';
const coverImage = 'https://cdn.magicpatterns.com/uploads/gnLDV2gCU1YJWAEPofM74r/Mapa_rapido_de_las_38_Flores_de_Bach.png';
const highlights = [{
  icon: '🔑',
  text: 'Palabras clave de las 38 Flores'
}, {
  icon: '🌸',
  text: 'Organizadas en sus 7 grupos emocionales'
}, {
  icon: '⚡',
  text: 'Diferenciales rápidos entre flores similares'
}, {
  icon: '👀',
  text: 'Las 38 de una sola mirada'
}, {
  icon: '📱',
  text: 'Lista para consultar en celular, tablet o imprimir'
}];
const steps = ['OBSERVÁ', 'DIFERENCIÁ', 'EXPLORÁ', 'PERSONALIZÁ'];
export function FlowerMapCard() {
  return <article className="relative mx-auto mt-8 max-w-5xl overflow-hidden rounded-3xl border-2 border-brand-rose/40 bg-brand-roseMist/40 p-6 md:p-8" data-id="element-91" data-mp="habwaaufhlxx">
      <span className="absolute right-4 top-4 rounded-full bg-brand-rose px-3 py-1 text-[10px] font-bold tracking-[.16em] text-white" data-id="element-92" data-mp="m2v7x29k2703">
        NUEVO
      </span>

      <div className="grid gap-6 md:grid-cols-[200px_1fr] md:items-center md:gap-8" data-id="element-93" data-mp="3ppvk2ucbyc5l">
        <div className="mx-auto w-44 md:mx-0 md:w-full" data-id="element-94" data-mp="ieu82b3d9bsj">
          <div className="overflow-hidden rounded-xl border border-brand-green/15 bg-white shadow-[0_10px_24px_rgba(14,42,30,.14)]" data-id="element-95" data-mp="igf3e2xi8yrg">
            <img src={coverImage} alt="Portada del Mapa Rápido de las 38 Flores de Bach, Botiquín Bach" loading="lazy" className="block aspect-[2/3] h-auto w-full object-cover" draggable={false} data-id="element-96" data-mp="8o9b0s3ccfbq" />
          </div>
        </div>

        <div className="min-w-0" data-id="element-97" data-mp="3qtmeanoia4sx">
          <p className="mb-3 inline-flex items-center gap-1.5 rounded-full border border-brand-rose/40 bg-white px-3 py-1 text-[11px] font-bold tracking-[.14em] text-brand-rose" data-id="element-98" data-mp="3qskrjly4ntvd">
            🌸 NUEVO RECURSO INCLUIDO
          </p>
          <h3 className="pr-16 font-serif text-2xl font-bold leading-tight text-brand-green md:text-3xl" data-id="element-99" data-mp="3gyazk5d3kxl6">
            🌸 Mapa Rápido de las 38 Flores de Bach™
          </h3>
          <p className="mt-2 font-display text-lg font-semibold italic leading-snug text-brand-greenMid md:text-xl" data-id="element-100" data-mp="1f5edzolkacmt">
            Las 38 Flores. Sus palabras clave. Todo en una referencia visual rápida.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-101" data-mp="3edmqebjufikk">
            Una guía de consulta diseñada para ayudarte a encontrar, comparar y recordar rápidamente las Flores de Bach
            sin tener que buscar entre páginas de teoría.
          </p>

          <ul className="mt-4 grid gap-2 text-sm text-brand-text sm:grid-cols-2" data-id="element-102" data-mp="3sc2vjy22510l">
            {highlights.map(item => <li key={item.text} className="flex items-start gap-2" data-id="element-103" data-mp="12nnkws76qew">
                <span aria-hidden="true" data-id="element-104" data-mp="3iclp3eezej3k">{item.icon}</span>
                <span data-id="element-105" data-mp="3nbovp3am0xdn">{item.text}</span>
              </li>)}
          </ul>

          <div className="leaf-rule my-5" aria-hidden="true" data-id="element-106" data-mp="26y85wmv6artv" />

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-107" data-mp="26wnf98bzbt1a">
            <p className="font-title text-[11px] font-bold tracking-[.12em] text-brand-goldDark md:text-xs" data-id="element-108" data-mp="2bycqop3468pw">
              {steps.join(' → ')}
            </p>
            <p className="text-sm font-bold text-brand-greenMid" data-id="element-109" data-mp="p14t7uenik6x">Incluido sin costo adicional con tu Botiquín Bach™</p>
          </div>
        </div>
      </div>
    </article>;
}